<script setup lang="ts">
import type { Branches } from "~/types/directus-collections.d.ts";

const branch = useAttrs().branch as Branches;

const { data: images } = await useAsyncData("branch_images", () =>
  useDirectus(
    readItems("branch_images", {
      fields: ["*", { image: ["*"] }],
      filter: {
        branch: { _eq: branch.id },
      },
      sort: "-date_created",
    })
  )
);
onMounted(() => {
  refreshNuxtData("branch_images");
});
</script>

<template>
  <CommonContainer tag="section" class="py-[--y-margin]">
    <CommonGallery v-if="images?.length" :images="images"></CommonGallery>
    <div v-else class="text-center text-2xl font-semibold">No Images Found</div>
  </CommonContainer>
</template>
